import React from "react";

export default ({ question, answer }) => (
  <div className="each-faq">
    {question}
    <p>{answer}</p>
  </div>
);
